module.exports = __webpack_public_path__ + "media/CARNET1.42d2434f.mp4";